import { v4 as uuid } from 'uuid';

import * as types from './types';
import { addAlert, setApplication } from "./appActions";
import { fetchStudentApplication } from "../libs/apiCalls";

export const getApplication = ( studentId, periodId ) => {
  return async dispatch => {
    dispatch(fetchApplicationRequest());
    try {
      const response = await fetchStudentApplication(studentId, periodId);
      if( response.status ) {
        dispatch(fetchApplicationSuccess());
        dispatch(setApplication(response.application));
      } else {
        dispatch(fetchApplicationFailure('Application not found!'));
        dispatch(addAlert('danger', 'Unable to fetch Application: ' + response.reason))
      }
    } catch (e) {
      console.error(e);
      dispatch(fetchApplicationFailure(e.message));
    }
  };
};

export const fetchApplicationRequest = () => {
  return {
    type: types.FETCH_APPLICATION_REQUEST
  }
};

export const fetchApplicationSuccess = () => {
  return {
    type: types.FETCH_APPLICATION_SUCCESS
  }
};

export const fetchApplicationFailure = (message) => {
  return {
    type: types.FETCH_APPLICATION_FAILURE,
    message
  }
};

export const updateBasicInfo = (updates) => {
  return {
    type: types.UPDATE_BASIC_INFO,
    updates
  }
};

export const updateEducationInfo = (updates) => {
  return {
    type: types.UPDATE_EDUCATION_INFO,
    updates
  };
};

export const setStep = (step) => {
  return {
    type: 'SET_STEP',
    step
  }
};

export const toggleSubmitted = () => {
  return {
    type: 'TOGGLE_SUBMITTED',
  }
};

export const addCollege = () => {
  const newCollege = {
    id: uuid(),
    courses: []
  };
  return {
    type: types.ADD_COLLEGE,
    newCollege
  }
};

export const removeCollege = (collegeId) => {
  return {
    type: types.REMOVE_COLLEGE,
    collegeId
  }
};

export const updateCollege = (collegeId, updates) => {
  return {
    type: types.UPDATE_COLLEGE,
    collegeId,
    updates
  }
};

export const addCourse = (collegeId) => {
  const newCourse = {
    id: uuid(),
    requirement: '',
    anatomy: false,
    physiology: false,
    micro: false,
    nutrition: false,
    medTerminology: false,
    pharmacology: false,
    humanDev: false,
    english: false,
    math: false,
    repeat: false
  };
  return {
    type: types.ADD_COURSE,
    collegeId,
    newCourse
  }
};

export const removeCourse = (collegeId, courseId) => {
  return {
    type: types.REMOVE_COURSE,
    collegeId,
    courseId
  }
};

export const updateCourse = (collegeId, courseId, updates) => {
  return {
    type: types.UPDATE_COURSE,
    collegeId,
    courseId,
    updates
  }
};

export const toggleConfirmation = (id) => {
  return {
    type: types.TOGGLE_CONFIRMATION,
    id
  }
};

export const setPasscode = (passcode) => {
  return {
    type: types.SET_PASSCODE,
    passcode
  }
}

export const toggleUpgradeOption = () => {
  return {
    type: types.TOGGLE_UPGRADE_OPTION
  }
};

export const setUpgradeOption = (upgradeOption) => {
  return {
    type: types.SET_UPGRADE_OPTION,
    upgradeOption
  }
};

export const updateApplication = (updates) => {
  return {
    type: types.UPDATE_APPLICATION_REQUEST,
    updates
  }
};

export const updateApplicationStatus = (status) => {
  return {
    type: types.UPDATE_APPLICATION_STATUS_REQUEST,
    status
  }
};

export const submitApplication = (application) => {
  return {
    type: types.SUBMIT_APPLICATION_REQUEST,
    application
  }
};

export const deleteApplication = (applicationId) => {
  return {
    type: types.DELETE_APPLICATION_REQUEST,
    applicationId
  }
};

export const saveEducationInfo = (education) => {
  return updateApplication({education});
};